<template>
	<div>
		<app-header />

		<div class="container page-project">
			<div class="my-3">
				<h1>{{ project.name }}</h1>
			</div>

			<div class="my-3">
				<dl>

					<div>
						<dt>{{ _lang("Domain") }}</dt>
						<dd>
							<span>{{ project.domain || _lang("(not set)") }}</span>
							<span class="hand text-primary" @click="openModalDomain">
								{{ _lang("Configure") }}
							</span>
						</dd>
					</div>
					<div>
						<dt>{{ _lang("Preview URL") }}</dt>
						<dd>
							<div v-if="!isEditing('slug')">
								<span class="mr-1">{{ url(project.slug) }}</span>
								<span
									class="hand text-primary"
									@click="formEdit('slug')"
									>{{ _lang("change") }}</span
								>
							</div>
							<form v-else @submit.prevent="formSubmit" class="d-flex">
								<input type="text" ref="formValue" class="form-control" @keyup.escape="formCancel" v-model="form.value" />
								<button class="btn btn-sm btn-primary" type="submit">Save</button>
								<button class="btn btn-sm" @click="formCancel">Cancel</button>
							</form>
						</dd>
					</div>
					<div>
						<dt>{{ _lang("Description") }}</dt>
						<dd>
							<div v-if="!isEditing('meta.description')">
								<span class="mr-1" v-if="project.meta && project.meta.description">{{
									project.meta.description
								}}</span>
								<span
									class="hand text-primary"
									@click="formEdit('meta.description')"
									>{{ _lang("change") }}</span
								>
							</div>
							<form v-else @submit.prevent="formSubmit" class="d-flex">
								<input type="text" class="form-control" @keyup.escape="formCancel" v-model="form.value" />
								<button class="btn btn-sm btn-primary" type="submit">Save</button>
								<button class="btn btn-sm" @click="formCancel">Cancel</button>
							</form>
						</dd>
					</div>
					<div>
						<dt>{{ _lang("State") }}</dt>
						<dd>
							<span v-if="project.is_published">
								<a @click.prevent="openModalUnpublish">
									<i class="state-published"></i>
									{{ _lang("Published") }}
								</a>
							</span>
							<span v-if="!project.is_published">
								<a @click.prevent="openModalPublish">
									<i class="state-unpublished"></i>
									{{ _lang("Unpublished") }}
								</a>
							</span>
						</dd>
					</div>
					<div>
						<dt>{{ _lang('Created date') }}</dt>
						<dd>
							<span :title="_lang('by').concat(' ').concat(user.email)">{{ dataTimeBr(project.created_at) }}</span>
						</dd>
					</div>
					<div>
						<dt>{{ _lang('Last updated') }}</dt>
						<dd>
							<span :title="_lang('by').concat(' ').concat(user.email)">{{ dataTimeBr(project.updated_at) }}</span>
						</dd>
					</div>


				</dl>

				<router-link
					class="btn btn-light btn-sm"
					:to="'/project/' + project.id + '/edit'"
					>{{ _lang("Edit project") }}</router-link
				>
				<router-link
					class="btn btn-light btn-sm"
					:to="{ name: 'project-tables', params: { project_id: project.id } }"
					>{{ _lang("Collections") }}</router-link
				>
				<router-link
					class="btn btn-light btn-sm"
					:to="{ name: 'redirects', params: { project_id: project.id } }"
					>{{ _lang("Redirects") }}</router-link
				>

				<router-link
					v-if="project.domain"
					class="btn btn-light btn-sm"
					:to="{ name: 'form-history', params: { project_id: project.id } }"
					>{{ _lang("Form history") }}</router-link
				>

				<a
					v-if="project.tables && project.tables.length > 0"
					class="btn btn-light btn-sm"
					:href="urladmin()"
					target="_blank"
					>{{ _lang("Client admin panel") }}</a
				>
			</div>

			<h4>{{ _lang("Pages") }}</h4>

			<table class="table">
				<tbody>
					<tr v-for="page in static_pages">
						<td>{{ page.name }}</td>
						<td class="text-nowrap">
							{{ page.slug }}
							<a
								class="ml-2"
								:href="url(project.slug, page.slug)"
								target="_blank"
							>
								<svg class="icosvg" viewBox="0 0 24 24">
									<path
										fill="currentColor"
										d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"
									/>
								</svg>
							</a>
						</td>
						<td class="text-right text-nowrap">
							<router-link
								class="btn btn-sm btn-primary mr-2"
								:to="'/project/' + project.id + '/' + page.id"
							>
								<span class="is-desktop">
									<span v-if="!page.output">{{ _lang("start building page") }}</span>
									<span v-else>{{ _lang("edit page") }}</span>
								</span>
								<svg class="is-mobile icosvg" viewBox="0 0 24 24">
									<path
										fill="currentColor"
										d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
									/>
								</svg>
							</router-link>

							<!-- menu de três pontinhos -->
							<div class="dropdown ml-1">
								<span
									class="btn btn-sm btn-light"
									@click="togglePageDropdown(page.id)"
								>
									&hellip;
								</span>
								<div
									class="dropdown-content"
									v-if="dropdownPageId === page.id"
									v-on-clickaway="closePageDropdown"
								>
									<button
										type="button"
										class="btn btn-sm btn-light btn-block"
										@click="duplicatePage(page)"
									>
										{{ _lang("Duplicate") }}
									</button>

									<!-- Delete habilitado para páginas normais -->
									<button
										v-if="page.slug !== '/'"
										type="button"
										class="btn btn-sm btn-link has-text-danger btn-block"
										@click="removePage(page); closePageDropdown();"
									>
										{{ _lang("Delete") }}
									</button>

									<!-- Delete desabilitado para a Home -->
									<button
										v-else
										type="button"
										class="btn btn-sm btn-link btn-block"
										disabled
										:title="_lang('Home page cannot be deleted')"
									>
										{{ _lang("Delete") }}
									</button>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<button class="btn btn-primary mb-4" @click="newPage">
				{{ _lang("New page") }}
			</button>

			<template v-if="cpt_pages.length">
				<h4>{{ _lang("Collection pages") }}</h4>
				<table class="table">
					<tbody>
						<tr v-for="page in cpt_pages">
							<td>{{ page.name }}</td>
							<td>{{ page.slug }}/*</td>
							<td class="text-right text-nowrap">
								<router-link
									class="btn btn-sm btn-primary mr-2"
									:to="'/project/' + project.id + '/' + page.id"
								>
									<span class="is-desktop"
										><span>{{ _lang("edit page") }}</span></span
									>
									<svg class="is-mobile icosvg" viewBox="0 0 24 24">
										<path
											fill="currentColor"
											d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
										/>
									</svg>
								</router-link>
							</td>
						</tr>
					</tbody>
				</table>
			</template>

			<button
				v-if="isAdmin"
				class="btn btn-warning"
				@click="openModalSaveTemplate"
			>
				{{ _lang("save as template") }}
			</button>
		</div>

		<project-publishing
			v-if="modalDomain"
			@update="getProject"
			@close="modalDomain = false"
			:project="project"
		/>

		<modal-save-template
			v-if="modalTemplate"
			@close="modalTemplate = false"
			:project="project"
		/>

		<modal-publish
			v-if="modalPublish"
			@close="modalPublish = false"
			:project="project"
		/>
		<modal-unpublish
			v-if="modalUnpublish"
			@close="modalUnpublish = false"
			@update="getProject"
			:project="project"
		/>
	</div>
</template>
<script>
import axios from "axios";
import { mixin as clickaway } from 'vue-clickaway';
import ProjectPublishing from "../components/ProjectPublishing.vue";
import ModalSaveTemplate from "../components/ModalSaveTemplate.vue";
import ModalPublish from "../components/ModalPublish.vue";
import ModalUnpublish from "../components/ModalUnpublish.vue";
import appHeader from "../components/appHeader.vue";

export default {
	name: "project",
	components: {
		appHeader,
		ProjectPublishing,
		ModalSaveTemplate,
		ModalPublish,
		ModalUnpublish,
	},
	// prop:['id'],
	mixins: [ clickaway ],
	props: ["id"],
	data() {
		return {
			modalDomain: false,
			modalTemplate: false,
			modalPublish: false,
			modalUnpublish: false,
			dropdownPageId: null,

			form: {
				field: "",
				value: "",
			},
		};
	},
	computed: {
		project() {
			return this.$store.getters.project;
		},
		isAdmin() {
			return this.$store.getters.user.is_admin;
		},
		user(){
			return this.$store.getters.user;
		},
		static_pages() {
			return this.project.pages.filter((page) => !page.table_id);
		},
		cpt_pages() {
			return this.project.pages.filter((page) => page.table_id);
		},
	},
	methods: {
		togglePageDropdown(pageId) {
			this.dropdownPageId = this.dropdownPageId === pageId ? null : pageId;
		},
		closePageDropdown() {
			this.dropdownPageId = null;
		},
		keyp(e){
			console.log(e)
		},
		isEditing(form) {
			return this.form.field == form;
		},
			formEdit(field) {
				this.form.field = field;
				if (field.match(/\./)) {
					var parts = field.split(/\./);
					this.form.value = this.project[parts[0]][parts[1]];
				} else {
					this.form.value = this.project[field];
				}
				this.$nextTick(function(){
					if (this.$refs.formValue) this.$refs.formValue.focus()
				})
			},
		formCancel() {
			this.form.field = "";
		},
		formSubmit() {
			if(this.form.field == 'slug'){
				if(!this.form.value.match(/^[a-z0-9-]+$/i)){
					alert(this._lang('Slug must contain only letters, numbers and dashes'));
					return
				}
			}

			var data = {};
			if (this.form.field.match(/\./)) {
				var parts = this.form.field.split(/\./);
				data[parts[0]] = { [parts[1]]: this.form.value };
			} else {
				data[this.form.field] = this.form.value;
			}

			axios
				.post("/api/projects/" + this.project.id, data)
				.then((res) => {
					this.$store.dispatch("setProject", res.data);
					this.formCancel();
				})
				.catch((err) => {
					alert(err.response.data);
					console.log(err);
				});
		},
		openModalSaveTemplate() {
			this.modalTemplate = true;
		},
		openModalDomain() {
			this.modalDomain = true;
		},
		openModalUnpublish() {
			this.modalUnpublish = true;
		},
		openModalPublish() {
			this.modalPublish = true;
		},
		url(slug, page) {
			var url =
				process.env.VUE_APP_PROTOCOL +
				"://" +
				slug +
				"." +
				process.env.VUE_APP_BASEURL;
			if (page) url += "/" + page.replace(/\/$/, "");
			return url;
		},
		urladmin() {
			var domain = this.project.domain;
			if (domain) {
				var url = "https://" + domain;
			} else {
				var url =
					process.env.VUE_APP_PROTOCOL +
					"://" +
					this.project.slug +
					"." +
					process.env.VUE_APP_BASEURL;
			}

			url += "/admin?token=" + this.project.token;
			return url;
		},
		dataTimeBr(data){
      var d = new Date(data);
      return ('0'+d.getDate()).substr(-2) + '/' +('0'+(d.getMonth()+1)).substr(-2)+'/'+d.getFullYear()+` ${('0'+d.getHours()).substr(-2)}:${('0'+d.getMinutes()).substr(-2)}`;
    },
dataBr(data) {
			var d = new Date(data);
			return (
				("0" + d.getDate()).substr(-2) +
				"/" +
				("0" + (d.getMonth() + 1)).substr(-2) +
				"/" +
				d.getFullYear()
			);
		},

		getProject() {
			this.$store.dispatch("startLoading");
			this.$store
				.dispatch("getProject", this.id)
				.catch((e) => {
					toastr(
						//this._lang("No permisson to view this project"),
						e.message,
						'Error',
						"#cc0000"
					);
					this.$router.replace("/");
				})
				.finally(() => {
					this.$store.dispatch("stopLoading");
				});
		},

		newPage() {
			let name = prompt(this._lang("Page title"));
			if (!name) return;

			axios({
				method: "post",
				url: "/api/pages",
				data: {
					name: name,
					project_id: this.id,
				},
			}).then((res) => {
				this.$router.push("/project/" + this.id + "/" + res.data.id);
			});
		},
		duplicatePage(page) {
			this.closePageDropdown();

			const name = prompt(
				this._lang("Page title"),
				page.name + " " + this._lang("(copy)")
			);

			if (!name) return;

			axios({
				method: "post",
				url: "/api/page/" + page.id + "/duplicate",
				data: {
					name: name.trim(),
				},
			})
			.then((res) => {
				// recarrega as páginas do projeto
				this.getProject();
			})
			.catch((err) => {
				alert(
					err.response && err.response.data
						? err.response.data
						: err.message
				);
				console.error(err);
			});
		},
		removePage(page) {
			if (!confirm(this._lang("Remove page?"))) return;
			axios({
				method: "delete",
				url: "/api/page/" + page.id,
			}).then((res) => {
				this.getProject();
			});
		},
	},
	mounted() {
		this.getProject();
	},
};
</script>

<style scoped>
.dropdown {
	position: relative;
	display: inline-block;
}

.dropdown .dropdown-content {
	position: absolute;
	right: 0;
	top: 100%;
	background: #f8f9fa;
	box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
	padding: 10px;
	z-index: 2;
	min-width: 120px;
}
</style>
